import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
export function OfferImage({ offer, styles, isMobile, onYesClick, }) {
    const showImage = styles.offerText?.show_image ?? true;
    const isProductCampaign = offer.campaign.is_product;
    if (!showImage || !offer.image) {
        return null;
    }
    // Determine image alignment: on mobile use align_image setting, on desktop always center
    const getImageAlignItems = () => {
        if (isMobile) {
            return styles.offerText?.align_image === 'left' ? 'flex-start' : 'center';
        }
        return 'center';
    };
    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: getImageAlignItems(),
        gap: '8px',
        width: isProductCampaign && !isMobile ? '30%' : 'auto',
        margin: '0',
    };
    const imageStyles = {
        maxWidth: isMobile ? '120px' : '140px',
        height: isMobile ? '120px' : '140px',
        objectFit: 'contain',
        cursor: 'pointer',
        borderRadius: '12px',
        WebkitBorderRadius: '12px',
    };
    const onClickImage = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onYesClick();
    };
    return (_jsxs(_Fragment, { children: [!isMobile && (_jsx("div", { className: 'adpx_img-container adpx_logo', id: 'adpx_img-container', style: containerStyles, children: _jsx("img", { className: 'adpx_img adpx_positive-cta', id: 'adpx_Logo', src: offer.image, alt: offer.title || 'Offer', style: imageStyles, onError: e => {
                        e.target.src = offer.image; // Fallback to main image
                    }, onClick: onClickImage }) })), isMobile && (_jsx("div", { id: 'adpx_image-container-mobile', style: containerStyles, children: _jsx("img", { className: 'adpx_img adpx_positive-cta', id: 'adpx_Logo-mobile', src: offer.image, alt: offer.title || 'Offer', style: imageStyles, onError: e => {
                        e.target.src = offer.image; // Fallback to main image
                    } }) }))] }));
}
